import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BasicTextArea, BasicFieldCheckbox } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function EligibilityStatusEditTemplate({ eligibilityStatusEditViewStore }) {
    const {
        contentLoading,
        form,
    } = eligibilityStatusEditViewStore;

    return (
        <ApplicationEditLayout store={eligibilityStatusEditViewStore}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-8 col-lrg-7">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicTextArea field={form.$('description')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicFieldCheckbox field={form.$('includeInsuranceOnFacilityInvoice')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Content>
        </ApplicationEditLayout>
    )
}

EligibilityStatusEditTemplate.propTypes = {
    eligibilityStatusEditViewStore: PropTypes.object
};

export default defaultTemplate(EligibilityStatusEditTemplate);
